import React from "react";

import type {
  CourtRetentionSettings,
  RetentionDraft,
  RetentionDraftMap,
} from "./RetentionSetting.types";
import RetentionSettingsModal from "./RetentionSettingsModal";
import RetentionSettingsTable from "./RetentionSettingsTable";

interface RetentionSettingsTabProps {
  courtSettings: CourtRetentionSettings[];
  editingCourt: string | null;
  tempEditData: RetentionDraftMap;
  isSavingCourt: boolean;
  onEditCourtChange: (id: string | null) => void;
  onCourtSettingUpdate: (
    id: string,
    field: keyof CourtRetentionSettings,
    value: RetentionDraft[keyof RetentionDraft],
  ) => void;
  onUpdateDuration: (id: string) => void;
}

const RetentionSettingsTab: React.FC<RetentionSettingsTabProps> = ({
  courtSettings,
  editingCourt,
  tempEditData,
  isSavingCourt,
  onEditCourtChange,
  onCourtSettingUpdate,
  onUpdateDuration,
}) => {
  const sortedSettings = [...courtSettings].sort(
    (a, b) => b.priority - a.priority,
  );
  const activeSetting =
    sortedSettings.find((setting) => setting._id === editingCourt) || null;

  return (
    <>
      {activeSetting && (
        <RetentionSettingsModal
          setting={activeSetting}
          draft={tempEditData[activeSetting._id] || {}}
          isSaving={isSavingCourt}
          onClose={() => onEditCourtChange(null)}
          onFieldChange={onCourtSettingUpdate}
          onSave={() => onUpdateDuration(activeSetting._id)}
        />
      )}

      <RetentionSettingsTable
        settings={sortedSettings}
        onEdit={onEditCourtChange}
      />
    </>
  );
};

export default RetentionSettingsTab;
